const Backbone = require('lib/backbone')
const RelatedModel = require('./related_model')
const DnsModel = require('./domain_dns')
const { THREE_HOURS, ONE_WEEK } = require('lib/time')
const log = require('log').create('domain') // eslint-disable-line

const Domain = RelatedModel.extend({

    defaults: {
        domain: '',
        title: '',
        description: '',
        analytics_id: '',
        registrar: '',
        source: '',
        canonical: null,
        purchase: null,
        dns: {
            id: 'dns',
        },
    },

    relations: [
        {
            type: Backbone.One,
            key: 'dns',
            relatedModel: DnsModel,
        },
    ],

    calculated_values: {
        dns_needs_checking() {
            // don't need to check DNS for purchased domains
            if (this.get('purchase')) return false

            const dns = this.get('dns')

            // get last_checked date
            const last_checked = dns.get('last_checked')

            // return true if never checked
            if (! last_checked) return true

            // return true if we have no records
            const records = dns.get('records')
            if (! records.length) return true

            // if DNS is valid, don't check more unless we haven't checked in a
            // week. if invalid, check after three hours
            const CHECK_PERIOD = (
                dns.isValid()
                    ? ONE_WEEK
                    : THREE_HOURS
            )

            // compare time since last checked with CHECK_PERIOD
            const since_last_checked = Date.now() - last_checked
            return (since_last_checked > CHECK_PERIOD)
        },
    },

    verifyDns(options) {
        return this.get('dns').fetch()
    },

    // helper method for DNS checks
    // verify DNS and call the callback
    // if DNS has already been verified, call the callback immediateley
    verifyDnsIfNeeded(cb) {
        if (this.get('dns_needs_checking')) {
            this.verifyDns().always(cb)
        } else {
            if (cb) cb()
        }
    },

    getOwner() {
        const owner = (
            this.collection
            && this.collection.parents
            && this.collection.parents[0]
        )
        return owner
    },

    isSubdomain() {
        const domain = this.get('domain')
        if (! domain) return false
        return domain.split('.').length > 2
    },

    parse(attrs) {
        if (attrs && attrs.dns) {
            attrs.dns.id = 'dns'
        }
        return attrs
    },

})

module.exports = Domain
